
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#FFF","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M1 9.31C1 5.716 6 0 6 0s5 5.716 5 9.31C11 12.931 8.455 15 6 15s-5-2.069-5-5.69h0z"}}),_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M4 11l2-6 2 6M5 8.5h2"}})])])
          )
        }
      }
    